/* eslint react/no-danger: 0 */
import React, { useRef } from 'react';
import Observer from 'react-intersection-observer';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';

import { GAfireEvent } from "../Tracking";
import { isEs } from "../../libs/lang";

/* eslint-disable global-require */
let content = {};

if (isEs()) {
	content = require('../../contentES').default;
} else {
	content = require('../../content').default;
}


const SubMasthead = props => {
	const copy = content.sustainability.masthead;
	const containerRef = useRef(null);


	return (
		<section className="sustainability__subMasthead" id="subMasthead" ref={containerRef}>
			<h2 dangerouslySetInnerHTML={{__html: copy.headline}}/>
			<Observer
				tag="div"
				className="container__copy"
				threshold={0.5}
				triggerOnce
			>
				{/*{copy.facets.map((x, i) => renderAccordion(x, i))}*/}
				{copy.facets.map((x, i) => {
					return (
						<div className={"facet"} key={`${Math.random() * 1000}-${i}`}>
							<p>{x}</p>
						</div>
					)
				})}
			</Observer>
		</section>
	);
};

export default SubMasthead;
